import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import "./PageHero.css";

const PageHero = ({ title, subtitle, badge, action }) => (
  <div className="page-hero d-flex flex-wrap justify-content-between align-items-start gap-3 mb-4">
    <div>
      <h5>{title}</h5>
      {subtitle ? <p>{subtitle}</p> : null}
    </div>
    <div className="d-flex flex-wrap align-items-center gap-2">
      {badge ? (
        <span className="page-hero-badge">
          {badge.icon ? <Icon icon={badge.icon} width={14} /> : null}
          {badge.label}
        </span>
      ) : null}
      {action}
    </div>
  </div>
);

export default PageHero;
